import { yupResolver } from "@hookform/resolvers/yup";
import { generateInputPasswordField } from "helpers/form_helper_old";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import MetaTags from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Row,
} from "reactstrap";
import { changePassword, logoutUser, resetChangePassword } from "store/actions";
import {
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
} from "store/auth/login/actionTypes";
import * as yup from "yup";
// import images
import profileImg from "../../assets/images/profile-img.png";

// import avatar from "../../assets/images/users/avatar-1.jpg";

const ChangePassword = () => {
  const history = useHistory();

  const [typeInputObject, setTypeInputObject] = useState({
    passwordOld: true,
    passwordNew: true,
    passwordNewConfirm: true,
  });

  const dispatch = useDispatch();
  const Login = useSelector(state => state.Login);
  const { changePasswordData, type } = Login;
  const { addToast } = useToasts();

  useEffect(() => {
    switch (type) {
      case CHANGE_PASSWORD_SUCCESS: {
        addToast("Thay đổi mật khẩu thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetChangePassword());
        setTimeout(() => {
          dispatch(logoutUser(history));
        }, 500);
        break;
      }
      case CHANGE_PASSWORD_FAIL:
        let errorMess = "Thay đổi mật khẩu thất bại";
        switch (changePasswordData.error) {
          case "ERRORS.PASSWORD_IS_NOT_CORRECT":
            errorMess = "Mật khẩu hiện tại không đúng";
            break;
          case "VALIDATION.EMAIL_IS_EXIST ":
            errorMess = "Email tài khoản không đúng";
            break;
          default:
            break;
        }
        addToast(errorMess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetChangePassword());
        break;
    }
  }, [type]);

  const schema = yup.object().shape({
    // email: yup
    //   .string()
    //   .email("Email không đúng định dạng")
    //   .required("Vui lòng nhập email"),
    passwordOld: yup.string().required("Vui lòng nhập mật khẩu hiện tại"),
    passwordNew: yup
      .string()
      .required("Vui lòng nhập mật khẩu mới")
      .min(8, "Mật khẩu phải có ít nhất 8 ký tự") // Độ dài tối thiểu
      .matches(/[A-Z]/, "Mật khẩu phải chứa ít nhất 1 chữ cái in hoa (A-Z)") // Chữ in hoa
      .matches(/[a-z]/, "Mật khẩu phải chứa ít nhất 1 chữ cái in thường (a-z)") // Chữ in thường
      .matches(/\d/, "Mật khẩu phải chứa ít nhất 1 chữ số (0-9)") // Chữ số
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt (!, @, #, $, %, ^, &...)"
      ) // Ký tự đặc biệt
      .notOneOf(
        [yup.ref("passwordOld")],
        "Mật khẩu mới phải khác mật khẩu hiện tại"
      ),
    passwordNewConfirm: yup
      .string()
      .required("Vui lòng nhập lại mật khẩu mới")
      .oneOf(
        [yup.ref("passwordNew")],
        "Mật khẩu nhập lại và mật khẩu mới phải giống nhau"
      ),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const onSubmit = values => {
    console.log(
      "🚀 ~ file: changePassword.js ~ line 74 ~ ChangePassword ~ values",
      values
    );
    dispatch(changePassword(values.passwordOld, values.passwordNew));
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Thay đổi mật khẩu</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs="7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Thay đổi mật khẩu</h5>
                        <p className="text-primary">4Si E-Invoice</p>
                      </div>
                    </Col>
                    <Col xs="5" className="align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <i
                            style={{ fontSize: "46px" }}
                            className="bx bxs-lock-alt align-middle me-1 text-info"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <div className="form-horizontal">
                      <div
                        className="user-thumb mb-3"
                        style={{
                          padding: "0px 10px",
                          fontSize: "14px",
                        }}
                      >
                        {/* <img
                          //   src={avatar}
                          className="rounded-circle img-thumbnail avatar-md"
                          alt="thumbnail"
                        /> */}
                        {/* <h5 className="font-size-15 mt-3">
                          Mật khẩu mới phải khác mật khẩu cũ
                        </h5> */}
                        * Sử dụng 8 ký tự trở lên bao gồm chữ hoa, chữ thường,
                        số, ký tự đặc biệt
                      </div>

                      <Row className="row-cols-1 row-cols-lg-1">
                        <Col>
                          <FormGroup className="mb-3">
                            {generateInputPasswordField(
                              "Mật khẩu hiện tại",
                              false,
                              "password",
                              errors,
                              touchedFields,
                              "passwordOld",
                              "Vui lòng nhập mật khẩu hiện tại",
                              register,
                              false,
                              typeInputObject.passwordOld,
                              () => {
                                setTypeInputObject({
                                  ...typeInputObject,
                                  passwordOld: !typeInputObject.passwordOld,
                                });
                              }
                            )}
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup className="mb-3">
                            {generateInputPasswordField(
                              "Mật khẩu mới",
                              false,
                              "password",
                              errors,
                              touchedFields,
                              "passwordNew",
                              "Vui lòng nhập mật khẩu mới",
                              register,
                              false,
                              typeInputObject.passwordNew,
                              () => {
                                setTypeInputObject({
                                  ...typeInputObject,
                                  passwordNew: !typeInputObject.passwordNew,
                                });
                              }
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup className="mb-3">
                            {generateInputPasswordField(
                              "Nhập lại mật khảu mới",
                              false,
                              "password",
                              errors,
                              touchedFields,
                              "passwordNewConfirm",
                              "Vui lòng nhập lại mật khẩu mới",
                              register,
                              false,
                              typeInputObject.passwordNewConfirm,
                              () => {
                                setTypeInputObject({
                                  ...typeInputObject,
                                  passwordNewConfirm:
                                    !typeInputObject.passwordNewConfirm,
                                });
                              }
                            )}
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="text-end">
                        <Col xs="12" className="text-end">
                          <Button
                            color="danger"
                            className=" w-md mr-2"
                            type="submit"
                            onClick={() => {
                              history.push("/dashboard");
                            }}
                          >
                            Trở về
                          </Button>
                          <Button
                            color="primary"
                            className=" w-md ml-2"
                            style={{
                              marginLeft: "5px",
                            }}
                            disabled={changePasswordData.loading}
                            type="submit"
                            onClick={() => {
                              handleSubmit(onSubmit)();
                            }}
                          >
                            Lưu
                          </Button>
                        </Col>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">
                <p>
                  Not you ? return{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    Sign In{" "}
                  </Link>{" "}
                </p>
                <p>
                  © 2021 Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ChangePassword;
